import { type ButtonHTMLAttributes } from 'react';
import { cn } from '../lib/cn';

export interface FilterChipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
}

export function FilterChip({
  selected = false,
  className,
  children,
  type = 'button',
  ...rest
}: FilterChipProps) {
  return (
    <button
      type={type}
      className={cn(
        'rounded-full px-3 py-1 text-sm font-medium transition-all duration-fast motion-reduce:transition-none',
        'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--tenant-primary,#FFE600)]',
        selected
          ? 'bg-[var(--tenant-primary,#FFE600)] text-yhelp-black shadow-sm'
          : 'border border-neutral-300 bg-white text-neutral-700 hover:bg-neutral-50 dark:border-neutral-700 dark:bg-neutral-900 dark:text-neutral-200 dark:hover:bg-neutral-800',
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
}
